import React, { useEffect } from 'react';
import './App.css';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-react-grids/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';

import { Route, createRoutesFromElements, RouterProvider, createBrowserRouter } from 'react-router-dom'; // Import Routes and Route from react-router-dom
import Home from './Components/Home';
import AboutPage from './Components/AboutPage';
import SignInPage from './Components/SignInPage';
import SignUpPage from './Components/SignUpPage';
import ContactPage from './Components/ContactPage';
import FoodOrder from './Components/FoodOrder';
import AdminDashboard from './Components/AdminDashboard';
import ContactAddress from './Components/ContactAddress';
import YourOrder from './Components/YourOrder';
import UserDashboard from './Components/UserDashboard';
import Profile from './Components/Profile';
import ShopDashboard from './Components/ShopDashboard';
import OwnShopDashboard from './Components/OwnShopDashboard';
import PaymentPage from './Components/PaymentPage';
import PaymentSuccessPage from './Components/PaymentSuccessPage';
import { useContextSelector } from 'use-context-selector';
import { StateContext } from './contexts/StateContext';
import { ACCESS_TOKEN, ADMIN, PUPIL } from './config/Config';
import { AuthProvider } from "./contexts/AuthContext";
import Inventory from './Components/Inventory';
import EditProduct from './Components/EditProduct';
import Sale from './Components/Sale';
import InvoicePopup from './Components/SuperAdmin/InvoicePopup';
import InvoiceDashboard from './Components/SuperAdmin/InvoiceDashboard';
import GstDashboard from './Components/SuperAdmin/GstDashboard';
import InventoryTable from './Components/SuperAdmin/InventoryTable';
import InvoiceDashboardNew from './Components/SuperAdmin/InvoiceDashBoardNew';

function App() {
  const isLoggedIn = useContextSelector(
    StateContext,
    (state) => state.isLoggedIn
  );
  const setIsLoggedIn = useContextSelector(
    StateContext,
    (state) => state.setIsLoggedIn
  );
  const setRole = useContextSelector(
    StateContext,
    (state) => state.setRole
  );
  const role = useContextSelector(StateContext, (state) => state.role);
  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        const decodedToken = JSON.parse(window.atob(base64));

        if (decodedToken.exp > Math.floor(Date.now() / 1000)) {
          setIsLoggedIn(true);
          setRole(localStorage.getItem('role'));
        } else {
          console.log("Token expired. Logging out...");
          localStorage.removeItem(ACCESS_TOKEN);
          localStorage.removeItem('role');
          setIsLoggedIn(false);
          setRole(null);
        }
      } catch (error) {
        console.error("Invalid token", error);
        localStorage.removeItem(ACCESS_TOKEN);
        setIsLoggedIn(false);
      }
    }
  }, []);
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route> {/* Wrap Routes here */}
        {isLoggedIn ? (<>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/yourorder" element={<YourOrder />} />
          <Route path="/profile" element={<Profile />} />
          {(role === ADMIN || role === PUPIL) && (<Route path="/userdashboard" element={<UserDashboard />} />)}
          {role === ADMIN && (<>
            <Route path="/editProduct/:_id" element={< EditProduct />} />
            <Route path="/admindashboard" element={<AdminDashboard />} />
            <Route path="/shopdashboard" element={<ShopDashboard />} />
            <Route path="/shopdashboard" element={<ShopDashboard />} />
            <Route path="/sale" element={<Sale />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/inventorytap" element={<InventoryTable />} />
            <Route path="/invoiceDashboard" element={<InvoiceDashboard />} />
            <Route path="/invoiceDashboardNew" element={<InvoiceDashboardNew />} />

            <Route path="/gstDashboard" element={<GstDashboard />} />
            <Route path="/invoiceDetail" element={<InvoicePopup />} />
          </>)}

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contactaddress" element={<ContactAddress />} />
          <Route path="/paymentpage" element={<PaymentPage />} />
          <Route path="/paymentsuccess" element={<PaymentSuccessPage />} />

          <Route path="/foodOrder" element={<FoodOrder />}>


            {/* Dynamic Route for FoodOrder details */}
            <Route path=":foodId" element={<FoodOrder />} />
          </Route>
        </>) : (<>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/yourorder" element={<YourOrder />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/userdashboard" element={<UserDashboard />} />
          <Route path="/admindashboard" element={<AdminDashboard />} />
          <Route path="/shopdashboard" element={<ShopDashboard />} />
          <Route path="/ownshopdashboard" element={<OwnShopDashboard />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contactaddress" element={<ContactAddress />} />
          <Route path="/paymentpage" element={<PaymentPage />} />
          <Route path="/paymentsuccess" element={<PaymentSuccessPage />} />
          <Route path="/foodOrder" element={<FoodOrder />}>
            {/* Dynamic Route for FoodOrder details */}
            <Route path=":foodId" element={<FoodOrder />} />
          </Route>
        </>)}

      </Route>
    )
  );
  return (
    <div className="font-bodyFont">
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </div>

  );
}

export default App;
